// extracted by mini-css-extract-plugin
export default {"font-renta":"ErrorCodesPage_font-renta__dZaSI","errorCodePage":"ErrorCodesPage_errorCodePage__qOMfY","tooltip":"ErrorCodesPage_tooltip__Dirhy"};